module.exports = __webpack_public_path__ + "img/artifact_attunement.6b690bbc.png";